// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width: 768px){.cookie__floating{max-width:600px}}.cookie__floating__buttons__button{white-space:break-spaces;width:50% !important}", ""]);
// Exports
module.exports = exports;
